package net.frozenbit.games.soundgame.dtos

import kotlinx.serialization.Serializable

@Serializable
sealed interface ControllerClientMessage

@Serializable
data class JoinGame(
    val sessionId: String?,
    val joinCode: String,
    val playerName: String,
    val avatarIndex: Int? = null,
) : ControllerClientMessage

@Serializable
data class UpdatePlayerInfo(
    val avatarIndex: Int,
) : ControllerClientMessage

@Serializable
data object StartGame : ControllerClientMessage

@Serializable
data class SelectPrompt(
    val selectedIndex: Int,
) : ControllerClientMessage

@Serializable
data class SelectSound(
    val selectedIndex: Int,
) : ControllerClientMessage

@Serializable
data class ReplaySound(
    val soundIndex: Int,
) : ControllerClientMessage

@Serializable
data class VoteForCreation(
    val selectedIndex: Int,
) : ControllerClientMessage

@Serializable
data class GameOverActionSelected(
    val selectedIndex: Int,
) : ControllerClientMessage